import { render } from "./MapWidget.vue?vue&type=template&id=4bba0aaa&scoped=true"
import script from "./MapWidget.vue?vue&type=script&lang=js"
export * from "./MapWidget.vue?vue&type=script&lang=js"

import "./MapWidget.vue?vue&type=style&index=0&id=4bba0aaa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4bba0aaa"

export default script